import { render, staticRenderFns } from "./modalEstadisticas.vue?vue&type=template&id=1dec216f&scoped=true"
import script from "./modalEstadisticas.vue?vue&type=script&lang=js"
export * from "./modalEstadisticas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec216f",
  null
  
)

export default component.exports